import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent implements OnInit {

  constructor(private titleService: Title, private metaService: Meta) { }

  ngOnInit() {
    this.titleService.setTitle('Privacy Policy - Golden Drop Oil');
    this.metaService.updateTag({ name: 'description', content: 'Read the privacy policy of GOLDOL Lubricants. Learn how we collect, use, and protect your data when you interact with our website and services.' });
    this.metaService.updateTag({ name: 'keywords', content: 'lubricant oil suppliers dubai' });
  }
}
